<main>
  <div class="page-container">
    @if (isDesktopLayout) {
      <div class="column left">
        <div class="texts-container">
          <h1 class="main-title-text" [innerHTML]="'LOGIN_PAGE.MAIN_TITLE' | translate" #mainTitleText></h1>
          <h2 class="subtitle-text">
            {{ 'LOGIN_PAGE.SUBTITLE_PREFIX' | translate }}
            <a [routerLink]="['/privacy-policy']">{{ 'LOGIN_PAGE.SUBTITLE_PRIVACY_POLICY' | translate }}</a>
            {{ 'LOGIN_PAGE.SUBTITLE_CONNECTOR' | translate }}
            <a [routerLink]="['/tos']">
              {{ 'LOGIN_PAGE.SUBTITLE_TERMS_OF_SERVICE' | translate }}
            </a>
            .
          </h2>
        </div>
      </div>
    }

    @if (!APIAvailable) {
      <app-login-api-unavailable-view (userLangChanged)="userLangChanged($event)"></app-login-api-unavailable-view>
    }

    @if (APIAvailable) {
      <div class="column right">
        <div class="utils-buttons-wrapper">
          <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
        </div>

        <div class="content-column" [class.force-center-align]="viewLoading">
          @if (viewLoading) {
            <nz-spin
              class="mobiapp-spin no-children xlarge"
              [nzTip]="'COMMON.GENERAL.LOADING_APPLICATION_DATA' | translate"
              nzSize="large"
              [nzSpinning]="true"
              [nzIndicator]="LanguagesLoadingSpinner">
            </nz-spin>
          }

          @if (currentUserLang?.key) {
            <div class="login-view-content" [class.login-view-content--preparing]="viewLoading">
              <div nz-row>
                <div nz-col [nzSpan]="24">
                  <div class="graphic-dot"></div>
                </div>
              </div>

              @if (isDesktopLayout) {
                <app-login-desktop-view #deviceView></app-login-desktop-view>
              }

              @if (!isDesktopLayout) {
                <app-login-mobile-view #deviceView></app-login-mobile-view>
              }
            </div>
          }
        </div>

        @if (!viewLoading) {
          <app-ue-finance-banner></app-ue-finance-banner>
        }
      </div>
    }
  </div>

  @if (safeLogoutInfo) {
    <div
      #safeLogoutInfoRef
      role="dialog"
      aria-modal="true"
      class="safe-logout-info"
      (click)="closeSafeLogoutInfo(); $event.stopPropagation(); $event.preventDefault()"
      (keydown.escape)="closeSafeLogoutInfo()"
      tabindex="0">
      <h2 [innerHTML]="'LOGIN_PAGE.YOU_HAVE_BEEN_SAFELY_LOGGED_OUT' | translate"></h2>
    </div>
  }
</main>
<app-cookie-banner></app-cookie-banner>

<ng-template #LanguagesLoadingSpinner>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
